import { render, staticRenderFns } from "./orderTracking.vue?vue&type=template&id=119887ce&scoped=true"
import script from "./orderTracking.vue?vue&type=script&lang=js"
export * from "./orderTracking.vue?vue&type=script&lang=js"
import style0 from "./orderTracking.vue?vue&type=style&index=0&id=119887ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119887ce",
  null
  
)

export default component.exports